module.exports = __webpack_public_path__ + "img/present.bce5d9d7.svg";